module.exports = __webpack_public_path__ + "img/j_lowcode.c801cb07.jpg";